import { useLocalSearchParams } from 'expo-router';
import TeamDetailLayout from '@/layouts/TeamDetail';

export default function PrivateTabsChatTeamTeamIdLayoutRoute() {
  const { teamId } = useLocalSearchParams<{ teamId: string }>();

  return (
    <TeamDetailLayout
      basePath="/chat/team/[teamId]"
      badgesPathname="/chat/team/[teamId]/badge"
      teamId={teamId}
    />
  );
}
